import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/get-active-discounts';

  return API({ endpoint });
}